import { render, staticRenderFns } from "./CalendarWidget.vue?vue&type=template&id=6f79b240&scoped=true&"
import script from "./CalendarWidget.vue?vue&type=script&lang=js&"
export * from "./CalendarWidget.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWidget.vue?vue&type=style&index=0&id=6f79b240&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f79b240",
  null
  
)

export default component.exports